import Config from '@config';
import { initializeMeteringNodeKindApi } from '@gasbi/shared/common/features/meteringNodeKind';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const meteringNodeKind = initializeMeteringNodeKindApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const { meteringNodeKindApi, useGetMeteringNodeKindQuery } =
  meteringNodeKind;
